import { render, staticRenderFns } from "./SetupUser.vue?vue&type=template&id=49d2b176&scoped=true&"
import script from "./SetupUser.vue?vue&type=script&lang=js&"
export * from "./SetupUser.vue?vue&type=script&lang=js&"
import style0 from "./SetupUser.vue?vue&type=style&index=0&id=49d2b176&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d2b176",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VForm,VRow,VSheet,VTextField})
